import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';

const referralService = () => {
  const getReferralInfo = async (params: string) => {
    return ChiroUpAPI.get('api-noauth', '/referral-price', {
      queryParams: {
        code: params,
      },
    });
  };
  return {
    getReferralInfo,
  };
};

export default referralService();
